// extracted by mini-css-extract-plugin
export default {"logoBackground":"Navbars_logoBackground__l0f-1","logo":"Navbars_logo__QUFiG"};